import React, { forwardRef, useContext } from 'react';
import type { ComponentType } from 'react';
import { ResponsiveContext } from './ResponsiveContext';

function Responsiveness(WrappedComponent: ComponentType<any>) {
  return forwardRef<any, any>(function Responsive(props, ref) {
    const responsive = useContext(ResponsiveContext);
    return <WrappedComponent ref={ref} {...props} responsive={responsive} />;
  });
}

export default Responsiveness;
